// @flow
import styled from 'styled-components'

export const StyledSelect = styled.div`
   margin-bottom: 10px
   .label {
    margin-bottom: 10px
   }
`
